import React from 'react'
import LandingLayout from '../../components/Layouts/LandingLayout'
import HeaderContainer from '../../modules/Portafolio/Header/Header.container'
import FooterContainer from '../../modules/Portafolio/Footer/Footer.container'
import ProjectDetailContainer from '../../modules/Portafolio/Project/ProjectDetail.container'

const ProjectDetailPage = () => {
  return (
    <LandingLayout header={<HeaderContainer />} footer={<FooterContainer />}>
      <ProjectDetailContainer />
    </LandingLayout>
  )
}

export default ProjectDetailPage
